import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Droplets, ShieldCheck, Compass } from 'lucide-react';
export function MethodSection() {
  const steps = [{
    id: 1,
    name: 'NUTRIR',
    icon: Droplets,
    desc: "Movilidad suave que baja la rigidez y 'engrasa' la articulación sin dolor.",
    color: 'bg-blue-100 text-blue-700'
  }, {
    id: 2,
    name: 'NORMALIZAR',
    icon: ShieldCheck,
    desc: 'Fuerza segura (sin castigo) para que la rodilla deje de sentirse floja o inestable.',
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    id: 3,
    name: 'NAVEGAR',
    icon: Compass,
    desc: 'Equilibrio + caminata guiada para recuperar la confianza real en tus pasos.',
    color: 'bg-amber-100 text-amber-700'
  }];
  return <Section background="white" data-id="element-77">
      <div className="text-center mb-16" data-id="element-78">
        <span className="text-[#C96B4B] font-bold tracking-wider uppercase text-sm" data-id="element-79">
          El Secreto
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mt-2 mb-6 font-serif" data-id="element-80">
          La Escalera 3N
        </h2>
        <p className="text-xl text-[#4A4A4A] max-w-2xl mx-auto" data-id="element-81">
          No haces "lo que toque". Haces lo que tu cuerpo acepta{' '}
          <span className="font-bold text-[#1A5F5A]" data-id="element-82">en el orden correcto</span>
          .
        </p>
      </div>

      <div className="relative" data-id="element-83">
        {/* Connecting Line (Desktop) */}
        <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-gray-100 -z-10" data-id="element-84"></div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-85">
          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.2
        }} viewport={{
          once: true
        }} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-shadow relative" data-id="element-86">
              <div className={`w-16 h-16 ${step.color} rounded-2xl flex items-center justify-center mb-6 mx-auto md:mx-0 shadow-inner`} data-id="element-87">
                <step.icon className="w-8 h-8" data-id="element-88" />
              </div>

              <div className="absolute top-6 right-6 text-4xl font-bold text-gray-100 font-serif select-none" data-id="element-89">
                0{step.id}
              </div>

              <h3 className="text-xl font-bold text-[#2D2D2D] mb-3" data-id="element-90">
                {step.name}
              </h3>
              <p className="text-[#4A4A4A] leading-relaxed" data-id="element-91">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}